<template>
  <div class="list-search-input-number">
    <el-input
      :value=inputValue[0]
      v-bind="$attrs"
      :field="field"
      :placeholder="pageText.minimumText"
      @input="(v)=>handleInput(v,0)"
      @blur="handleBlurValidateMin"
    />
    <div class="line">-</div>
    <el-input
      :value=inputValue[1]
      v-bind="$attrs"
      :field="field"
      :placeholder="pageText.maximumText"
      @input="(v)=>handleInput(v,1)"
      @blur="handleBlurValidateMax"
    />
  </div>
</template>

<script>
  import i18n from './i18n.js'
  import TransformMixin from 'fe-coms-share/paas/business/field-precision/percentage-mixin.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'list-search-input-number',
    data () {
      return {
        pageText,
        value: [],
        inputValue: ['', '']
      }
    },
    model: {
      prop: 'values',
      event: 'change'
    },
    props: {
      values: {
        type: Array,
        default: ['', '']
      },
      percentileValue: {
        type: Boolean,
        default: false
      },
      field: {
        type: Object,
        default: ()=>({})
      }
    },
    mixins: [TransformMixin],
    watch: {
      values: {
        immediate: true,
        handler (val) {
          this.value = [...val]
        }
      }
    },
    mounted () {
      // 进页面默认回显
      if (this.field.type === 'paas-percentage') {
        this.inputValue = this.percentileValue ? this.values : [this.correctStrNum(this.transform(this.values[0])),this.correctStrNum(this.transform(this.values[1]))]
        // 回显formData value的值
        this.$emit('input', this.percentileValue ?  [this.correctStrNum(this.transform(this.values[0], 'divide')), this.correctStrNum(this.transform(this.values[1], 'divide'))] : this.values)
      } else {
        this.inputValue = this.values || this.inputValue
      }

    },
    methods: {
      handleInput (value,number) {
        if (this.field.type === 'paas-percentage') {
          // eslint-disable-next-line no-useless-escape
          const P_REG = /[\u4e00-\u9fa5a-z_A-Z!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\`\?:;|]+$/g
          const REGEXP = /[^\-\d^\\.]+/g
          let payAmount = value.replace(P_REG, '').replace(/\s*/g, '').replace(REGEXP, '').replace('/\s/g', '').replace(/-/g, (_, index) => index === 0 ? '-' : '')
          this.inputValue[number] = typeof payAmount === 'string' ? payAmount : JSON.stringify(payAmount)
          this.value[number] = this.correctStrNum(this.transform(payAmount, 'divide'))
        } else {
          this.value[number] = value
          this.inputValue[number] = value
        }
        this.$emit('change', this.value)
      },
      handleBlurValidateMin () {
        if (this.value[0] === null) return false
        if (!this.value[0].length) return false
        if (this.isNumber(this.value[0])) {
          if (this.isNumber(this.value[1]) && Number(this.value[0]) > Number(this.value[1])) {
            let value = this.value[1]
            if (this.field.type === 'paas-percentage') value = this.correctStrNum(this.transform(value))
            this.$message.error(`${this.pageText.pleaseEnterLessThan}${value}${this.pageText.valueOf}`)
            this.value[0] = ''
            this.inputValue[0] = ''
            this.$emit('change', this.value)
            return false
          }
        } else {
          this.$message.error(this.pageText.withinFiveDigits)
          this.value[0] = ''
          return false
        }
      },
      handleBlurValidateMax () {
        if (this.value[1] === null) return false
        if (!this.value[1].length) return false
        if (this.isNumber(this.value[1])) {
          if (this.isNumber(this.value[0]) && Number(this.value[1]) < (Number(this.value[0]))) {
            let value = this.value[0]
            if (this.field.type === 'paas-percentage') value = this.correctStrNum(this.transform(value))
            this.$message.error(`${this.pageText.pleaseEnterMoreThan}${value}${this.pageText.valueOf}`)
            this.value[1] = ''
            this.inputValue[1] = ''
            this.$emit('change', this.value)
            return false
          }
        } else {
          this.$message.error(this.pageText.withinFiveDigits)
          this.value[1] = ''
          return false
        }
      },
      isNumber (val) {
        if (val === null) return false
        return /^-?\d+(\.\d{1,5})?$/.test(val)
      }
    }
  }
</script>

<style scoped lang="scss">
  .list-search-input-number {
    display: flex;
    align-items: center;
    .line {
      margin: 0 10px;
    }
  }
</style>
